"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerBurnedBudgetRatio = exports.BURNED_BUDGET_WARNING_RANGE = exports.BURNED_BUDGET_OK_RANGE = exports.CustomerBurnedBudgetRatioStatus = void 0;
var CustomerBurnedBudgetRatioStatus;
(function (CustomerBurnedBudgetRatioStatus) {
    CustomerBurnedBudgetRatioStatus[CustomerBurnedBudgetRatioStatus["OK"] = 0] = "OK";
    CustomerBurnedBudgetRatioStatus[CustomerBurnedBudgetRatioStatus["WARNING"] = 1] = "WARNING";
    CustomerBurnedBudgetRatioStatus[CustomerBurnedBudgetRatioStatus["ALARM"] = 2] = "ALARM";
})(CustomerBurnedBudgetRatioStatus || (exports.CustomerBurnedBudgetRatioStatus = CustomerBurnedBudgetRatioStatus = {}));
exports.BURNED_BUDGET_OK_RANGE = 0.05;
exports.BURNED_BUDGET_WARNING_RANGE = 0.15;
class CustomerBurnedBudgetRatio {
    constructor(total, burned, now = new Date()) {
        this.total = total;
        this.burned = burned;
        this.now = now;
    }
    getExpectedHoursRatio() {
        const now = this.now;
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        return now.getDate() / lastDay.getDate();
    }
    getExpectedHoursPercent() {
        return Math.round(this.getExpectedHoursRatio() * 100);
    }
    getExpectedHours() {
        return Math.round(this.total * this.getExpectedHoursRatio());
    }
    getBurnedHoursRatio() {
        return this.total > 0 ? this.burned / this.total : 0;
    }
    getBurnedHoursPercent() {
        return Math.round(this.getBurnedHoursRatio() * 100);
    }
    getBurnedHours() {
        return Math.round(this.burned);
    }
    getBurnedHoursInBudget() {
        return Math.min(this.total, this.burned);
    }
    getBurnedHoursInBudgetRatio() {
        return this.total > 0 ? this.getBurnedHoursInBudget() / this.total : 0;
    }
    getBurnedHoursInBudgetPercent() {
        return Math.round(this.getBurnedHoursInBudgetRatio() * 100);
    }
    getBurnedHoursOverBudget() {
        return Math.max(0, this.burned - this.total);
    }
    getBurnedHoursOverBudgetRatio() {
        return this.total > 0 ? this.getBurnedHoursOverBudget() / this.total : 0;
    }
    getBurnedHoursOverBudgetPercent() {
        return Math.round(this.getBurnedHoursOverBudgetRatio() * 100);
    }
    getStatus() {
        const expectedRatio = this.getExpectedHoursRatio();
        const actualRatio = this.getBurnedHoursRatio();
        const okLowerLimit = Math.max(0, expectedRatio - exports.BURNED_BUDGET_OK_RANGE);
        const okUpperLimit = Math.min(1, expectedRatio + exports.BURNED_BUDGET_OK_RANGE);
        if (actualRatio >= okLowerLimit && actualRatio <= okUpperLimit) {
            return CustomerBurnedBudgetRatioStatus.OK;
        }
        const warningLowerLimit = Math.max(0, expectedRatio - exports.BURNED_BUDGET_WARNING_RANGE);
        if (actualRatio >= warningLowerLimit && actualRatio <= 1) {
            return CustomerBurnedBudgetRatioStatus.WARNING;
        }
        return CustomerBurnedBudgetRatioStatus.ALARM;
    }
    isOK() {
        return this.getStatus() === CustomerBurnedBudgetRatioStatus.OK;
    }
}
exports.CustomerBurnedBudgetRatio = CustomerBurnedBudgetRatio;
//# sourceMappingURL=CustomerBurnedBudgetRatio.js.map